import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredGroup?: 'administrator' | 'suggestion-viewer' | 'question-editor' | 'question-viewer'
}

export function ProtectedRoute({ children, requiredGroup }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading, hasGroup } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mb-4 text-lg font-medium">Loading...</div>
          <div className="text-sm text-muted-foreground">Checking authentication status.</div>
        </div>
      </div>
    )
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }

  // Check if user has required group
  if (requiredGroup && !hasGroup(requiredGroup)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mb-4 text-lg font-medium text-destructive">Access Denied</div>
          <div className="text-sm text-muted-foreground">
            You don't have permission to access this page.
          </div>
          <div className="mt-4 text-sm text-muted-foreground">
            Required role: <span className="font-medium">{requiredGroup}</span>
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
